<template>
    <div class="newsDetail">
      <div class="product-img">
        <img :src="application.imageHost+newsDetail.logoPath">
      </div>
      <div class="newsContent">
        <div class="newsContent_header">
            <div class="newsContent_header_title">{{newsDetail.name}}</div>
          <div class="newsContent_header_time">来源：{{newsDetail.author}}&nbsp;&nbsp;&nbsp;&nbsp;时间：{{newsDetail.createTime}}</div>
          <div class="line"></div>
          <div class="newsContent_header_content" v-html="newsDetail.content"></div>


<!--          <div class="newsContent_header_time margin_10">©Copyright 上海熔光信息科技有限公司 版权所有</div>-->
<!--          <div class="line"></div>-->
        </div>
      </div>
    </div>
</template>
<style src="./newsDetail.css" scoped></style>

<script>
    import mixins from '../../common/mixin';
    import application from '../../common/application'
    export default {
        name: "newsDetail",
        data:()=>({
            application:application,

            newsDetail:{},

        }),
        mixins:[mixins],
        mounted() {
            this.handleNewsDetail()

        },
        methods:{
            handleNewsDetail(){
                this.request({
                    url: '/web/news/detail',
                    data:{
                        "id":this.$route.params.id

                    },
                    success: (response) => {
                    console.log(response.data)
                        this.newsDetail=response.data;
                        this.newsDetail.createTime=this.formatDate(new Date(parseFloat(this.newsDetail.createTime)),'yyyy-MM-dd hh:mm')
                    },
                    error: (response) => {
                        this.$Message.error(response.message);
                    },
                    complete: () => {
                    }
                });
            },

        }
    }
</script>

<style >
  .MsoNormal>span>img{
    width: 70% !important;
  }
  .newsContent_header_content>p>img{
    width: 70%!important;
    margin: 10px auto;
  }

</style>



// WEBPACK FOOTER //
// src/pages/newsDetail/newsDetail.vue